import './spinner.scss';

export function Spinner() {
  return <div className="spinner"></div>;
}
